module.exports = __webpack_public_path__ + "img/35@2x.46f2c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/35@2x.png
// module id = 9Se/
// module chunks = 0